export default __webpack_public_path__ + "static/media/126.7657ef0b.jpg";